
import { RevLink } from '@ds/components/Link'
import isEmpty from 'lodash/isEmpty'

export default {
  components: {
    RevLink,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    labels: {
      type: Array,
      default: () => [],
    },
    hyperlink: {
      type: Object,
      default: null,
    },
  },
  computed: {
    showLink() {
      return !isEmpty(this.hyperlink)
    },
  },
}
